import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IBaseModel } from 'src/app/models/base.model';
import { IFasesAtividadeModel } from 'src/app/models/fases-atividade-model';
import { PapeisTrabalhoService } from 'src/app/services/papeis-trabalho.service';
import Swal from 'sweetalert2';
import { BaseFormComponent } from '../../shared/components/base-form/base-form.component';
import { IPapeisTrabalhoModel } from 'src/app/models/papeis-trabalho-model';
import { FaseAtividadeService } from 'src/app/services/fase-atividade.service';
import { TipoTrabalhoService } from 'src/app/services/tipo-trabalho.service';
import { AtividadeTipoTrabalhoService } from 'src/app/services/atividade-tipo-trabalho.service';
import { FiltroModel } from 'src/app/models/filtro.model';
import { IAtividadeTipoTrabalhoModel } from 'src/app/models/atividade-tipo-trabalho.model';

@Component({
  selector: 'app-papeis-trabalho-form',
  templateUrl: './papeis-trabalho-form.component.html',
  styleUrls: ['./papeis-trabalho-form.component.scss']
})
export class PapeisTrabalhoFormComponent extends BaseFormComponent implements OnInit {
  public model:IPapeisTrabalhoModel = {} as IPapeisTrabalhoModel;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private papeisTrabalhoService: PapeisTrabalhoService,
    public matDialog: MatDialog,
    private atividadeTipoTrabalhoService: AtividadeTipoTrabalhoService,
    private tipoTrabalhoService: TipoTrabalhoService
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.novoRegistro) {
      this.titulo = 'Novo Papel de Trabalho';
    }
  }

  listTipoTrabalho: any[] = [];
  listFases: any[] = [];
  listTodasFases: IAtividadeTipoTrabalhoModel[] = [];

  listSituacao: any[] = [
    {
      codigo: 1,
      descricao: 'Obrigatório'
    },
    {
      codigo: 2,
      descricao: 'Opcional'
    }
  ];

  txtNome: string;
  selectedTipo: number;
  selectedFase: number;
  selectedSituacao: number;
  checkColetado: boolean = false;
  checkNaoColetado: boolean = false;
  checkProduzido: boolean = false;

  listPapeis: IPapeisTrabalhoModel[] = [];
  listRemovidos: IPapeisTrabalhoModel[] = [];

  async ngOnInit() {
    this.listRemovidos = [];
    try {
      await this.carregaFases();
      await this.carregaTiposTrabalho();

      if (!this.novoRegistro) {
        const res = await this.papeisTrabalhoService.obterPorAgrupamento(this.id);
        if (res.sucesso) {
          this.listPapeis = res.dados as IPapeisTrabalhoModel[];
          this.editar(this.listPapeis.find(f => f.id == this.id));

          if (this.visualizar) {
            this.titulo = 'Visualizar Papel de Trabalho - ' + this.model.nome;
          }
          else {
            this.titulo = 'Editar Papel de Trabalho - ' + this.model.nome;
          }

        } else {
          this.exibirMensagemErro(res.mensagem.descricao);
          this.router.navigate(['/papeis-trabalho']);
          return;
        }
      }
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
      this.router.navigate(['/papeis-trabalho']);
    } 
  }

  async carregaFases() {
    let filtro = {} as FiltroModel;
    filtro.ativo = true;
    const res = await this.atividadeTipoTrabalhoService.obterTodos(filtro);
    if (res.sucesso) {
      this.listTodasFases = res.dados as IAtividadeTipoTrabalhoModel[];          
    }
  }

  changeTipo(element: any) {
    this.carregaFasesPorTipo(element.target.value);
  }

  carregaFasesPorTipo(idTipo: number) {
    this.listFases = [];    
    if (this.listTodasFases != null && this.listTodasFases.length > 0) {
      let tipo = this.listTodasFases.find(f => f.tipoTrabalho.id == idTipo);
      if (tipo != null && tipo.fases != null && tipo.fases.length > 0) {
        this.listFases = tipo.fases;
      }        
    }
  }

  async carregaTiposTrabalho() {
    const res = await this.tipoTrabalhoService.obter();
    if (res.sucesso) {
      this.listTipoTrabalho = res.dados;      
    }
  }

  public async salvarDados(salvarEFechar: boolean)
  {        
    this.submit = true;
    if (this.listPapeis == null || this.listPapeis.length == 0) {
      this.exibirMensagemAlerta('Adicione um ou mais Papéis de Trabalho');
      return;
    }

    this.atualizarModel();

    try {
      let res: IBaseModel<void> = null;

      // if (!this.novoRegistro) {
      //   res = await this.papeisTrabalhoService.atualizar(this.model);
      // } else {
      //  res = await this.papeisTrabalhoService.inserir(this.listPapeis);
      //}      

      //console.log(this.listPapeis);
      //console.log(this.listRemovidos);
      res = await this.papeisTrabalhoService.inserir(this.listPapeis, this.listRemovidos);

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          icon: 'success',
          text: res.mensagem.descricao
        });

        if(salvarEFechar == true) {
          this.router.navigate(['/papeis-trabalho']);
        }          
        else {
          Object.assign(this.model, res.dados);
          if (this.novoRegistro) {            
            this.router.navigate([`/papeis-trabalho/${this.model.id}`]);
          }
          else {
            this.id = this.model.id;
            this.ngOnInit();
          }           
        }
      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    }
    catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  private atualizarModel() {
    this.model.id = this.model.id;
    this.model.nome = this.txtNome;
    this.model.idTipo = this.selectedTipo;
    this.model.idFase = this.selectedFase;
    this.model.idSituacao = this.selectedSituacao;
    this.model.ativo = true;
    this.model.checkColetado = this.checkColetado;
    this.model.checkNaoColetado = this.checkNaoColetado;
    this.model.checkProduzido = this.checkProduzido;
    this.model.tipoNome = "";
    this.model.faseNome = "";
    this.model.situacaoNome = ""; 
    this.model.controle = 0;
  }

  public onBack() {
    this.router.navigate(['/papeis-trabalho']);
  }

  public cancelar() {
    this.router.navigate(['/papeis-trabalho']);
  }

  atualizaElement(element: IPapeisTrabalhoModel, editObj: IPapeisTrabalhoModel) {
    element.nome = editObj.nome;
    element.idTipo = editObj.idTipo;
    element.idFase = editObj.idFase;
    element.idSituacao = editObj.idSituacao;
    element.checkColetado = editObj.checkColetado;
    element.checkNaoColetado = editObj.checkNaoColetado;
    element.checkProduzido = editObj.checkProduzido;          
    element.faseNome = this.listFases.find(f => f.id == editObj.idFase).nome;
    element.tipoNome = this.listTipoTrabalho.find(f => f.id == editObj.idTipo).nome;
    element.situacaoNome = this.listSituacao.find(f => f.codigo == editObj.idSituacao).descricao;
    this.limpar();
  }

  validaForm(campo: string) {
    //console.log(campo);
    switch(campo) {
      case "nome":
        return (this.txtNome == null || this.txtNome == "")

      case "tipo":
        return (this.selectedTipo == null || this.selectedTipo == 0)

      case "fase":
        return (this.selectedFase == null || this.selectedFase == 0)

      case "situacao":
        return (this.selectedSituacao == null || this.selectedSituacao == 0)

      case "checks":
        return (this.checkColetado == false && this.checkNaoColetado == false && this.checkProduzido == false)

      default:
        return false;
    }
  }

  validaAdd() {
    if (this.txtNome == null || this.txtNome == "")
      return false;

    if (this.selectedTipo == null || this.selectedTipo == 0)
      return false;

    if (this.selectedFase == null || this.selectedFase == 0)
      return false;

    if (this.selectedSituacao == null || this.selectedSituacao == 0)
      return false;

    return true;
  }

  add() {
    if (this.validaAdd() == false) {
      this.exibirMensagemAlerta('Formulário inválido');
      return;
    }

    this.atualizarModel();

    if (this.listPapeis == null || this.listPapeis == undefined)
      this.listPapeis = [];

    const editObj:IPapeisTrabalhoModel = {} as IPapeisTrabalhoModel;
    Object.assign(editObj, this.model);
    console.log(editObj);

    if (editObj.checkColetado == false && editObj.checkNaoColetado == false && editObj.checkProduzido == false) {
      this.exibirMensagemAlerta('Selecione pelo menos 1 item dos Tipos de Papéis Aceitáveis');
      return;
    }

    if (editObj.id > 0) {
      if (this.listPapeis.some(s => s.id !== editObj.id && (s.nome + s.idTipo + s.idFase) === (editObj.nome + editObj.idTipo + editObj.idFase))) {
        this.exibirMensagemAlerta('Este nome de Papel de Trabalho já foi adicionado com esse Tipo e Fase!');
        return;
      }        
      this.listPapeis.forEach(element => {
        if (element.id === editObj.id) {
          this.atualizaElement(element, editObj);
        }
      });
    }
    else if (editObj.controle > 0) {
      if (this.listPapeis.some(s => s.controle !== editObj.controle && (s.nome + s.idTipo + s.idFase) === (editObj.nome + editObj.idTipo + editObj.idFase))) {
        this.exibirMensagemAlerta('Este nome de Papel de Trabalho já foi adicionado com esse Tipo e Fase!');
        return;
      }

      this.listPapeis.forEach(element => {
        if (element.controle === editObj.controle) {
          this.atualizaElement(element, editObj);          
        }
      });
    }
    else {
      if (this.listPapeis.some(s => (s.nome + s.idTipo + s.idFase) === (editObj.nome + editObj.idTipo + editObj.idFase))) {
        this.exibirMensagemAlerta('Este nome de Papel de Trabalho já foi adicionado com esse Tipo e Fase!');
        return;
      }

      editObj.id = 0,        
      editObj.faseNome = this.listFases.find(f => f.id == editObj.idFase).nome;
      editObj.tipoNome = this.listTipoTrabalho.find(f => f.id == editObj.idTipo).nome;
      editObj.situacaoNome = this.listSituacao.find(f => f.codigo == editObj.idSituacao).descricao;
      editObj.controle = this.listPapeis.length + 1;  
      this.listPapeis.push(editObj);
      this.limpar();
    }        
  }

  remover(item: IPapeisTrabalhoModel) {    
    if (item.id > 0) {
      if (this.listRemovidos == null)
        this.listRemovidos = [];

      let removido = this.listPapeis.find(f => f.id == item.id);
      this.listRemovidos.push(removido);

      this.listPapeis = this.listPapeis.filter(f => f.id != item.id);
      if (this.model.id == item.id)
        this.limpar();
    }
    else {
      this.listPapeis = this.listPapeis.filter(f => f.controle != item.controle); 
    }    
  }

  async editar(item: IPapeisTrabalhoModel) {  
    this.model.id = item.id;
    this.model.controle = item.controle;
    this.model.nome = item.nome;
    this.txtNome = item.nome;
    this.model.idTipo = item.idTipo;
    this.selectedTipo = item.idTipo;
    this.carregaFasesPorTipo(item.idTipo);

    this.model.idFase = item.idFase;
    this.selectedFase = item.idFase;
    this.model.idSituacao = item.idSituacao;
    this.selectedSituacao = item.idSituacao;

    this.model.checkColetado = item.checkColetado;
    this.model.checkNaoColetado = item.checkNaoColetado;
    this.model.checkProduzido = item.checkProduzido;

    this.checkColetado = item.checkColetado;
    this.checkNaoColetado = item.checkNaoColetado;
    this.checkProduzido = item.checkProduzido;
  }

  limpar() {    
    this.model = {} as IPapeisTrabalhoModel;
    this.model.id = 0;
    
    this.selectedTipo = null;
    this.selectedFase = null;
    this.selectedSituacao = null;
    this.checkColetado = false;
    this.checkNaoColetado = false;
    this.checkProduzido = false;
  }
}
